import { CombinationFormFields } from '@/components/question/forms/combination/CombinationForm';
import { useObjectUrls } from '@/data/hook/shared/useObjectUrls';
import { DNDPositionalQuestion } from '@/models/Question';
import adapterCombinationForm from '@/utils/questions/adapterCombinationForm';

export function useCombinationPreviewQuestion(
  fields: CombinationFormFields,
): DNDPositionalQuestion {
  const files = [...(fields.questions ?? []), ...(fields.answers ?? [])]
    .map(item => item.mediaFile)
    .filter((mediaFile): mediaFile is File => mediaFile instanceof File);

  const urlByFile = useObjectUrls(files);

  return adapterCombinationForm(fields, mediaFile => {
    if (mediaFile instanceof File) {
      return urlByFile.get(mediaFile) ?? null;
    }
    return typeof mediaFile === 'string' ? mediaFile : null;
  });
}
